// extracted by mini-css-extract-plugin
module.exports = {"sell-product":"Penjualan_sell-product__2ruVD","select":"Penjualan_select__2XW13","sell-request":"Penjualan_sell-request__52QaQ"};